<div class="modal-header">
  <h4 class="modal-title" id="myLargeModalLabel">{{ data.mensaje }}</h4>
  <!--     <button [mat-dialog-close]="{'action': 1, 'data': myGroup.value.ListEmails}" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
 -->
  <div class="loader"></div>
</div>
